import { get } from 'lodash';
import * as Yup from 'yup';

export const columns = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'first_name', headerName: 'First Name', width: 160 },
  { field: 'last_name', headerName: 'Last Name', width: 200 },
  { field: 'type', headerName: 'Type', width: 160 },
  { field: 'email', headerName: 'Email', width: 200 },
  { field: 'phone', headerName: 'Phone Number', width: 200 },
  { field: 'address', headerName: 'Address', width: 200 },
  { field: 'city', headerName: 'City', width: 200 },
  { field: 'state', headerName: 'Province/State', width: 200 },
  { field: 'postal_code', headerName: 'Postal/ZIP Code', width: 200 },
  { field: 'country', headerName: 'Country', width: 200 },
];

export const suggestionPrimaryKey = 'first_name';
export const suggestionSecondaryKeys = [
  'type',
  'email',
  'phone',
  'address',
  'city',
  'state',
  'postal_code',
  'country',
];

export const initialValues = (staff) => {
  const { phone, mileage_rate: mileageRate } = staff || {};
  return {
    firstName: get(staff, 'first_name', ''),
    lastName: get(staff, 'last_name', ''),
    email: get(staff, 'email', ''),
    phone: phone || '',
    address: get(staff, 'address', ''),
    city: get(staff, 'city', ''),
    state: get(staff, 'state', ''),
    postalCode: get(staff, 'postal_code', ''),
    country: get(staff, 'country', ''),
    type: get(staff, 'type', ''),
    rate: get(staff, 'rate', ''),
    mileageRate: mileageRate || '',
  };
};

export const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('field is required'),
  lastName: Yup.string().required('field is required'),
  email: Yup.string().required('field is required'),
  phone: Yup.string(),
  address: Yup.string().required('field is required'),
  city: Yup.string().required('field is required'),
  state: Yup.string().required('field is required'),
  postalCode: Yup.string().required('field is required'),
  country: Yup.string().required('field is required'),
  type: Yup.string().required('field is required'),
  rate: Yup.string().required('field is required'),
  mileageRate: Yup.string(),
});
